import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  rowContainer: {
    display: 'grid',
    gridTemplateColumns: '9fr 31fr',
    alignItems: 'center',
    // borderTop: `1px dashed ${theme.palette.grey[300]}`,
    borderBottom: `1px dashed ${theme.palette.grey[300]}`
    // padding: theme.spacing(1, 0)
  },
  entityName: {
    color: theme.palette.text.primary
  },
  entityNameContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: `1px dashed ${theme.palette.grey[300]}`,
    height: '100%'
  },
  assignmentCells: {
    display: 'grid',
    gap: 3
    // padding: 10
  },
  assignmentCell: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    // padding: theme.spacing(1),
    gap: 3,
    // borderLeft: '1px solid black',
    // textAlign: 'center',
    borderRadius: 16,
    boxShadow: 'none'
  },
  emptyCell: {
    height: '100%',
    color: theme.palette.primary.main
  },
  termName: {
    fontSize: 12,

    color: theme.palette.grey[800]
  },
  termCode: {
    fontSize: 11,

    color: theme.palette.grey[600]
  },
  dateRange: {
    display: 'flex',
    fontSize: 11,
    color: theme.palette.primary.main,
    alignItems: 'center'
  },
  calendarIcon: {
    width: 16,
    marginRight: 4
  },
  addButton: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    backgroundColor: theme.palette.primary.light,
    height: '100%',
    padding: 10,
    borderRadius: 8
  },
  addIcon: {},
  addText: {
    fontSize: 12,

    color: theme.palette.primary.main
  },

  startsBefore: {
    borderRadius: '0 16px 16px 0',
    background:
      'linear-gradient(90deg,rgba(191,10,48,0.1) 1%, rgba(0,0,0,0.1) 4%, rgba(248,248,248,1) 15% )'
  },

  endsAfter: {
    borderRadius: '16px 0 0 16px',
    background:
      'linear-gradient(90deg, rgba(248,248,248,1) 85%, rgba(0,0,0,0.1) 96%, rgba(191,10,48,0.1) 99%)'
  }
}))

export default useStyles
